import { combineReducers } from 'redux'

import ApiReducer from './ApiSlice'

// Combines slices together into a single obj

const RootReducer = combineReducers({
  api: ApiReducer,
})

export default RootReducer